module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('layouts.sidebar.reports')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.reports.clients.title'),
      "name": "clients"
    }
  }, [_c('el-row', {
    staticClass: "margin-b-10",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 20
    }
  }, [_c('el-input', {
    staticClass: "mr-10 m-auto mb-10",
    attrs: {
      "placeholder": _vm.$t('static.reports.clients.clientSearch.placeholder'),
      "size": "medium",
      "clearable": ""
    },
    model: {
      value: (_vm.clientSearch),
      callback: function($$v) {
        _vm.clientSearch = $$v
      },
      expression: "clientSearch"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "mr-10 mb-10",
    attrs: {
      "filterable": "",
      "placeholder": "Select",
      "size": "medium"
    },
    model: {
      value: (_vm.selectedYear),
      callback: function($$v) {
        _vm.selectedYear = $$v
      },
      expression: "selectedYear"
    }
  }, _vm._l((_vm.yearList), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "el-button mr-10 mb-10 small el-button--default",
    attrs: {
      "type": "button",
      "disabled": _vm.disableBulk,
      "loading": _vm.buttonBulkDownloadLoading
    },
    on: {
      "click": _vm.downloadSelectedClient
    }
  }, [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.downloadTurnover')))]), _vm._v(" "), _c('el-button', {
    staticClass: "el-button ml-0-important mr-10 mb-10 small el-button--default",
    attrs: {
      "type": "button",
      "disabled": _vm.disableBulk,
      "loading": _vm.buttonBulkSendLoading
    },
    on: {
      "click": _vm.sendSelectedClient
    }
  }, [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.emailTurnover')))])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.clientList
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "selectable": _vm.selectable
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "btn-group margin-b-10 margin-r-10"
        }, [_c('button', {
          staticClass: "btn btn-danger",
          attrs: {
            "disabled": "",
            "type": "button"
          }
        }, [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.groupButton')))]), _vm._v(" "), _c('el-button', {
          staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
          attrs: {
            "type": "button",
            "loading": _vm.buttonLoading[scope.row.id],
            "data-toggle": "dropdown"
          },
          on: {
            "click": function($event) {
              return _vm.toggleDropdown(scope.row)
            }
          }
        }, [_c('span', {
          staticClass: "sr-only"
        })]), _vm._v(" "), _c('div', {
          staticClass: "dropdown-menu",
          class: {
            show: _vm.dropdownState[scope.row.id]
          }
        }, [_c('a', {
          staticClass: "dropdown-item",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              return _vm.viewTurnoverReport(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.viewTurnover')))]), _vm._v(" "), _c('a', {
          staticClass: "dropdown-item",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              return _vm.sendClient(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.emailTurnover')))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "id",
      "label": _vm.$t('table.clientReports.id'),
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "name",
      "label": _vm.$t('table.clientReports.name'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "clientNumber",
      "label": _vm.$t('table.clientReports.clientNumber'),
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "balance",
      "label": _vm.$t('table.clientReports.balance'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "createdAt",
      "label": _vm.$t('table.clientReports.createdAt'),
      "sortable": ""
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.reports.sales.title'),
      "name": "sales"
    }
  }, [_c('el-row', {
    staticClass: "margin-b-10",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 8
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('span', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.sales.dateRange.placeholder')) + ":\n                ")])]), _vm._v(" "), _c('v-date-range', {
    attrs: {
      "name": "salesDateRange",
      "value": _vm.salesDateRange,
      "disabled": _vm.loadingSales,
      "translation": "static.reports.sales.dateRange"
    },
    on: {
      "change": _vm.onFilterChange
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 4
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('span', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.sales.group.placeholder')) + ":\n                ")])]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "salesGrouping",
      "value": _vm.salesGrouping,
      "disabled": _vm.loadingSales,
      "options": _vm.salesGroupingOptions,
      "translation": "static.reports.sales.group"
    },
    on: {
      "change": _vm.onFilterChange
    },
    model: {
      value: (_vm.salesGrouping),
      callback: function($$v) {
        _vm.salesGrouping = $$v
      },
      expression: "salesGrouping"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 4
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('span', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.sales.type.placeholder')) + ":\n                ")])]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "salesType",
      "value": _vm.salesType,
      "disabled": _vm.loadingSales,
      "options": _vm.salesTypeOptions,
      "translation": "static.reports.sales.type"
    },
    on: {
      "change": _vm.onFilterChange
    },
    model: {
      value: (_vm.salesType),
      callback: function($$v) {
        _vm.salesType = $$v
      },
      expression: "salesType"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 5
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('span', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.sales.filter.placeholder')) + ":\n                ")])]), _vm._v(" "), _c('v-text', {
    attrs: {
      "name": "salesFilter",
      "type": "text",
      "value": _vm.salesFilter,
      "disabled": _vm.loadingSales,
      "translation": "static.reports.sales.filter"
    },
    on: {
      "keydown": _vm.onFilterChangeDebounce
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 2
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('span', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n                   \n                ")])]), _vm._v(" "), _c('el-button', {
    staticClass: "small dark-outline",
    on: {
      "click": _vm.downloadSalesReport
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.sales.export')) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 3
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('span', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n                   \n                ")])]), _vm._v(" "), _c('el-button', {
    staticClass: "small dark-outline",
    on: {
      "click": _vm.downloadYtdSalesReport
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.sales.exportYtd')) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('v-table', {
    attrs: {
      "list": _vm.salesList,
      "noDataMessage": _vm.$t('static.reports.noData'),
      "translation": "static.reports.sales"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.reports.aggregatedSales.title'),
      "name": "aggregatedSales"
    }
  }, [_c('el-row', {
    staticClass: "margin-b-10",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 4
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.dateRange.placeholder')) + ":")])]), _vm._v(" "), _c('v-date-range', {
    staticStyle: {
      "width": "100%",
      "height": "36px"
    },
    attrs: {
      "name": "aggSalesDateRange",
      "value": _vm.aggSalesDateRange,
      "disabled": _vm.loadingAggSales,
      "translation": "static.reports.sales.dateRange"
    },
    on: {
      "change": _vm.onAggSalesFilterChange
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 4
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.groupBy.placeholder')) + ":")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": _vm.$t('static.reports.aggregatedSales.groupBy.placeholder'),
      "disabled": _vm.loadingAggSales,
      "size": "medium"
    },
    on: {
      "change": _vm.showAggSales
    },
    model: {
      value: (_vm.aggSalesGroupBy),
      callback: function($$v) {
        _vm.aggSalesGroupBy = $$v
      },
      expression: "aggSalesGroupBy"
    }
  }, _vm._l((_vm.aggSalesGroupByOptions), function(opt) {
    return _c('el-option', {
      key: opt.id,
      attrs: {
        "label": opt.name,
        "value": opt.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 4
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.statuses.label')) + ":")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": _vm.$t('static.reports.aggregatedSales.statuses.placeholder'),
      "disabled": _vm.loadingAggSales,
      "size": "medium"
    },
    on: {
      "change": _vm.showAggSales
    },
    model: {
      value: (_vm.aggSalesStatuses),
      callback: function($$v) {
        _vm.aggSalesStatuses = $$v
      },
      expression: "aggSalesStatuses"
    }
  }, _vm._l((_vm.aggSalesStatusOptions), function(opt) {
    return _c('el-option', {
      key: opt.id,
      attrs: {
        "label": opt.name,
        "value": opt.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 4
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.sort.placeholder')) + ":")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.loadingAggSales,
      "size": "medium"
    },
    on: {
      "change": _vm.showAggSales
    },
    model: {
      value: (_vm.aggSalesSort),
      callback: function($$v) {
        _vm.aggSalesSort = $$v
      },
      expression: "aggSalesSort"
    }
  }, _vm._l((_vm.aggSalesSortOptions), function(opt) {
    return _c('el-option', {
      key: opt.id,
      attrs: {
        "label": opt.name,
        "value": opt.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 4
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "gap": "10px",
      "flex-wrap": "wrap"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.loadingAggSales
    },
    on: {
      "change": _vm.showAggSales
    },
    model: {
      value: (_vm.aggSalesIncludeCancelled),
      callback: function($$v) {
        _vm.aggSalesIncludeCancelled = $$v
      },
      expression: "aggSalesIncludeCancelled"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.aggregatedSales.includeCancelled')) + "\n                ")]), _vm._v(" "), _c('el-button', {
    staticClass: "small dark-outline",
    attrs: {
      "disabled": _vm.loadingAggSales
    },
    on: {
      "click": _vm.downloadAggSalesReport
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.aggregatedSales.export')) + "\n                ")])], 1)])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "margin-b-10",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('span', {
    staticClass: "margin-r-10"
  }, [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.metrics.label')) + ":")]), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "display": "inline-flex",
      "flex-wrap": "wrap",
      "gap": "4px 16px"
    },
    model: {
      value: (_vm.aggSalesMetrics),
      callback: function($$v) {
        _vm.aggSalesMetrics = $$v
      },
      expression: "aggSalesMetrics"
    }
  }, _vm._l((_vm.aggSalesMetricOptions), function(opt) {
    return _c('el-checkbox', {
      key: opt.id,
      attrs: {
        "label": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.aggSalesSummary) ? _c('el-row', {
    staticClass: "margin-b-10",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('div', {
    staticClass: "summary-bar"
  }, [_c('span', {
    staticClass: "summary-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.summary.totalRevenueNet')) + ":")]), _vm._v(" " + _vm._s(_vm.aggFmtSumCurrency(_vm.aggSalesSummary.total_revenue_net)))]), _vm._v(" "), _c('span', {
    staticClass: "summary-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.summary.totalVolumeliters')) + ":")]), _vm._v(" " + _vm._s(_vm.aggFmtSumVolume(_vm.aggSalesSummary.total_volume_liters)) + " L")]), _vm._v(" "), _c('span', {
    staticClass: "summary-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.summary.orderCount')) + ":")]), _vm._v(" " + _vm._s(_vm.aggSalesSummary.order_count))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.loadingAggSales) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "min-height": "80px",
      "background": "transparent"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingAggSales && _vm.aggSalesData.length === 0) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.reports.noData')))])])], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingAggSales && _vm.aggSalesData.length > 0) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.aggSalesData,
      "stripe": ""
    }
  }, [_vm._l((_vm.aggSalesDynamicColumns), function(col) {
    return _c('el-table-column', {
      key: col.key,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "min-width": col.minWidth,
        "sortable": ""
      }
    })
  }), _vm._v(" "), (_vm.aggSalesMetrics.includes('totalRevenueNet')) ? _c('el-table-column', {
    attrs: {
      "prop": "totalRevenueNet",
      "label": _vm.$t('static.reports.aggregatedSales.columns.totalRevenueNet'),
      "formatter": _vm.aggFmtCurrency,
      "min-width": "140",
      "sortable": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.aggSalesMetrics.includes('totalRevenueGross')) ? _c('el-table-column', {
    attrs: {
      "prop": "totalRevenueGross",
      "label": _vm.$t('static.reports.aggregatedSales.columns.totalRevenueGross'),
      "formatter": _vm.aggFmtCurrency,
      "min-width": "150",
      "sortable": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.aggSalesMetrics.includes('totalVolumeLiters')) ? _c('el-table-column', {
    attrs: {
      "prop": "totalVolumeLiters",
      "label": _vm.$t('static.reports.aggregatedSales.columns.totalVolumeLiters'),
      "formatter": _vm.aggFmtVolume,
      "min-width": "120",
      "sortable": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.aggSalesMetrics.includes('orderCount')) ? _c('el-table-column', {
    attrs: {
      "prop": "orderCount",
      "label": _vm.$t('static.reports.aggregatedSales.columns.orderCount'),
      "formatter": _vm.aggFmtInt,
      "min-width": "90",
      "sortable": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.aggSalesMetrics.includes('totalQuantityUnits')) ? _c('el-table-column', {
    attrs: {
      "prop": "totalQuantityUnits",
      "label": _vm.$t('static.reports.aggregatedSales.columns.totalQuantityUnits'),
      "formatter": _vm.aggFmtQty,
      "min-width": "80",
      "sortable": ""
    }
  }) : _vm._e()], 2)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.reports.bills.title'),
      "name": "bills"
    }
  }, [_c('el-row', {
    staticClass: "margin-b-10",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 8
    }
  }, [_c('v-date-range', {
    attrs: {
      "name": "billsDateRange",
      "value": _vm.billsDateRange,
      "disabled": _vm.loadingBills,
      "translation": "static.reports.sales.dateRange"
    },
    on: {
      "change": _vm.onFilterChange
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 5
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.billClientId),
      callback: function($$v) {
        _vm.billClientId = $$v
      },
      expression: "billClientId"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": _vm.$t('static.reports.bills.allClients'),
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.clientList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 8
    }
  }, [_c('el-button', {
    staticClass: "small dark-outline",
    on: {
      "click": _vm.downloadBillReport
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.bills.export')) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('v-table', {
    attrs: {
      "list": _vm.billList,
      "noDataMessage": _vm.$t('static.reports.noData'),
      "link": _vm.link,
      "linkKey": "invoiceNumber",
      "rowKey": "id",
      "translation": "static.reports.bills"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.reports.warehouse.warehouse'),
      "name": "warehouse"
    }
  }, [_c('el-row', {
    staticClass: "margin-b-10",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.dateOption),
      callback: function($$v) {
        _vm.dateOption = $$v
      },
      expression: "dateOption"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "as_of_date"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.reports.warehouse.as_of_date')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "date_range"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.reports.warehouse.date_range')))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "margin-b-10",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 20
    }
  }, [(_vm.showDateRange) ? _c('div', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.warehouse),
      callback: function($$v) {
        _vm.warehouse = $$v
      },
      expression: "warehouse"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": _vm.$t('static.reports.warehouse.all'),
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.warehouses.items), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.transaction_type_id),
      callback: function($$v) {
        _vm.transaction_type_id = $$v
      },
      expression: "transaction_type_id"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": _vm.$t('static.reports.warehouse.transactionType.all'),
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.transactionTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": ((item.description) + " (" + (item.code) + ")"),
        "value": item.id
      }
    })
  })], 2), _vm._v(" "), _c('v-date-range', {
    attrs: {
      "name": "transactionDateRange",
      "value": _vm.transactionDateRange,
      "translation": "static.reports.sales.dateRange"
    },
    on: {
      "change": _vm.onTransactionDateRangeChange
    }
  }), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.groupByProduct),
      callback: function($$v) {
        _vm.groupByProduct = $$v
      },
      expression: "groupByProduct"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.reports.warehouse.transactionType.groupByProduct')))])], 1) : _vm._e(), _vm._v(" "), (_vm.showAsOfDate) ? _c('div', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.warehouse),
      callback: function($$v) {
        _vm.warehouse = $$v
      },
      expression: "warehouse"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": _vm.$t('static.reports.warehouse.all'),
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.warehouses.items), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.transaction_type_id),
      callback: function($$v) {
        _vm.transaction_type_id = $$v
      },
      expression: "transaction_type_id"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": _vm.$t('static.reports.warehouse.transactionType.all'),
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.transactionTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": ((item.description) + " (" + (item.code) + ")"),
        "value": item.id
      }
    })
  })], 2), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('static.reports.warehouse.pick_date')
    },
    model: {
      value: (_vm.asOfDate),
      callback: function($$v) {
        _vm.asOfDate = $$v
      },
      expression: "asOfDate"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.groupByProduct),
      callback: function($$v) {
        _vm.groupByProduct = $$v
      },
      expression: "groupByProduct"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.reports.warehouse.transactionType.groupByProduct')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.hideOutOfStock),
      callback: function($$v) {
        _vm.hideOutOfStock = $$v
      },
      expression: "hideOutOfStock"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.products.hideOutOfStock')))])], 1) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 4
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.warehouseLoading
    },
    on: {
      "click": _vm.showWarehouses
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.fees.filter')) + "\n                ")]), _vm._v(" "), _c('el-button', {
    staticClass: "small dark-outline",
    on: {
      "click": _vm.downloadWarehousesReport
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.fees.export')) + "\n                ")])], 1)])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [(_vm.groupByProduct) ? _c('v-table', {
    attrs: {
      "list": _vm.warehouseList,
      "noDataMessage": _vm.$t('static.reports.noData'),
      "translation": "table.warehouseReports"
    }
  }) : (_vm.transactionListNew) ? _c('v-table', {
    attrs: {
      "list": _vm.transactionListNew,
      "noDataMessage": _vm.$t('static.products.transactions.noDataMsg'),
      "rowKey": "id,key",
      "translation": "static.products.transactions.table"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingExcise),
      expression: "loadingExcise"
    }],
    attrs: {
      "label": _vm.$t('static.reports.exciseEntry.title'),
      "name": "excise"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.exciseLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exciseLoading),
      expression: "exciseLoading"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "flex stretch wrap"
  }, _vm._l((_vm.excisePeriods.items), function(p, i) {
    return _c('v-card', {
      key: i,
      nativeOn: {
        "click": function($event) {
          return _vm.viewExciseMonthlyReport(p)
        }
      }
    }, [_c('label', {
      staticClass: "cardLabel"
    }, [_c('span', {
      staticClass: "cardBadge",
      class: _vm.exciseStatusClass(p.exciseStatus)
    }, [_vm._v(_vm._s(_vm.$t(("static.reports.fees.exciseStatus." + (_vm.camalize(p.exciseStatus))))))])]), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(p.monthName))]), _vm._v(" "), _c('hr')])
  }), 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.excisePeriods.pagination,
      "switchFunction": _vm.showExcise
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Grønt Punkt",
      "name": "greenDot"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [_c('div', {
    staticClass: "year-select"
  }, [_c('el-select', {
    staticClass: "margin-r-10",
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.greenDotSelectedYear),
      callback: function($$v) {
        _vm.greenDotSelectedYear = $$v
      },
      expression: "greenDotSelectedYear"
    }
  }, _vm._l((_vm.yearList), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "small dark-outline",
    on: {
      "click": _vm.generateGreenDotReport
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.downloadReport')) + "\n              ")]), _vm._v(" "), _c('el-button', {
    staticClass: "small dark-outline",
    on: {
      "click": _vm.generateGreenDotDetailedReport
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.greenDot.detailed.downloadDetailedReport')) + "\n              ")])], 1)])], 1), _vm._v(" "), (_vm.account.stockReportBeta) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.reports.warehouse.warehouse_beta'),
      "name": "warehouse_beta"
    }
  }, [_c('el-row', {
    staticClass: "margin-b-10",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.warehouse),
      callback: function($$v) {
        _vm.warehouse = $$v
      },
      expression: "warehouse"
    }
  }, _vm._l((_vm.warehouses.items), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "Pick a month"
    },
    model: {
      value: (_vm.transactionMonth),
      callback: function($$v) {
        _vm.transactionMonth = $$v
      },
      expression: "transactionMonth"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "small dark-outline",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadWarehousesReportBeta($event)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.fees.export')) + "\n              ")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a91dd2cc","hasScoped":false}!./src/app/pages/withNavigation/reports/reports.html
// module id = 3105
// module chunks = 1